import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import Button from '@/ui-kit/components/Button/Button';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList/DataList';

type Payload = {
  depositAmount: number;
};
type Props = ModalProps<Payload>;

const OverduePaymentSuccess = ({ confirmAction, payload }: Props) => {
  const { t } = useTranslation(['Modal', 'Common', 'Button']);
  const { depositAmount } = payload;

  return (
    <Modal title={t('OverduePaymentSuccess.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('OverduePaymentSuccess.disclaimer')}</p>
        <DataList>
          <DataListItem>
            <DataListLabel>{t('OverduePaymentSuccess.info')}</DataListLabel>
            <DataListValue>{t('Common:money', { amount: depositAmount })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <Button onClick={confirmAction}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default OverduePaymentSuccess;
